import { createReducer, on } from '@ngrx/store';
import * as headerAction from './header.action'
export const initialState = {
    title: '',
    icon: ''
  };

export const headerReducer = createReducer(
  initialState,
  on(headerAction.updateHeaderTitle, (state, { title }) =>  ({ ...state, title})),
  on(headerAction.updateHeaderIcon, (state, { icon }) =>  ({ ...state, icon}))
);
